export const richtwertEinheit = {
  euro: 'euro',
  stunden: 'stunden',
  exakt: 'exakt',
} as const;

export type RichtwertEinheit = keyof typeof richtwertEinheit;
